import { FC } from 'react';
// components
import EditProductTypeComponent from 'components/main/ProductType/Edit';

const EditProductType: FC = () => <EditProductTypeComponent />;

export default EditProductType;
